import GET_BUYING_SESSION_GROUP_NAME from './getBuyingSessionGroupName.graphql'

export default GET_BUYING_SESSION_GROUP_NAME
